(function () {
  function init(root) {
    if (root.getAttribute('data-ps-init')) return;
    root.setAttribute('data-ps-init', '1');

    var main = root.querySelector('[data-ps-main]');
    var corner = root.querySelector('[data-ps-corner]');
    var design = root.getAttribute('data-design') === 'true';
    var days = parseFloat(root.getAttribute('data-days')) || 0;
    var delay = parseInt(root.getAttribute('data-delay'), 10) || 0;
    var base = 'ps_' + root.id + '_v' + root.getAttribute('data-version');

    if (!design && root.getAttribute('data-mobile') !== 'true' && window.matchMedia('(max-width: 767px)').matches) return;

    function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function write(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    function hidden(k) { if (design) return false; var t = parseInt(read(k), 10); return !!t && Date.now() < t; }
    function remember(k) { if (!design && days > 0) write(k, String(Date.now() + days * 864e5)); }

    var cornerClosed = false;
    var withMain = root.getAttribute('data-corner-timing') !== 'after_close';
    function showCorner() {
      if (!corner || cornerClosed || !corner.hidden || hidden(base + '_c')) return;
      corner.hidden = false;
      requestAnimationFrame(function () { corner.classList.add('is-open'); });
    }
    function closeCorner() {
      if (!corner) return;
      cornerClosed = true;
      corner.classList.remove('is-open');
      setTimeout(function () { corner.hidden = true; }, 300);
      remember(base + '_c');
    }
    var card = main && main.querySelector('.ps-card');
    var mq = window.matchMedia('(max-width: 767px)');
    var land = window.matchMedia('(max-height: 500px) and (orientation: landscape)');

    // Shrink the card width (never the image crop) so image + text fit the screen height.
    function fit() {
      if (!card || main.hidden) return;
      card.style.maxWidth = '';
      var media = card.querySelector('.ps-media');
      var body = card.querySelector('.ps-body');
      if (!media || !body) return;
      var split = card.classList.contains('ps-card--split') && !mq.matches;
      var r = parseFloat(media.getAttribute(mq.matches ? 'data-ratio-m' : 'data-ratio-d'));
      if (split || land.matches || !r) return;
      var cs = getComputedStyle(main);
      var avail = main.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
      var full = card.getBoundingClientRect().width;
      var w = full;
      for (var i = 0; i < 3; i++) {
        var need = w / r + body.offsetHeight;
        if (need <= avail + 1) break;
        w = Math.max(260, Math.floor((avail - body.offsetHeight) * r));
        card.style.maxWidth = w + 'px';
        if (w === 260) break;
      }
    }

    function openMain() {
      main.hidden = false;
      fit();
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () { main.classList.add('is-open'); });
      var c = main.querySelector('[data-ps-close]');
      if (c) c.focus();
    }
    function closeMain() {
      main.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { main.hidden = true; }, 250);
      remember(base + '_m');
      showCorner();
    }

    if (main) {
      window.addEventListener('resize', function () { if (root.isConnected) fit(); });
      main.addEventListener('click', function (e) {
        if (e.target === main || e.target.closest('[data-ps-close]')) closeMain();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.isConnected && !main.hidden) closeMain();
      });
      main.querySelectorAll('[data-ps-copy]').forEach(function (b) {
        b.addEventListener('click', function () {
          var label = b.textContent;
          var done = function () { b.textContent = '\u2713'; setTimeout(function () { b.textContent = label; }, 1500); };
          if (navigator.clipboard) navigator.clipboard.writeText(b.getAttribute('data-ps-copy')).then(done, done);
          else done();
        });
      });
    }

    if (corner) {
      var cb = corner.querySelector('[data-ps-close-corner]');
      if (cb) cb.addEventListener('click', closeCorner);
      var cd = corner.querySelector('[data-ps-end]');
      if (cd) {
        var end = new Date(cd.getAttribute('data-ps-end').replace(' ', 'T')).getTime();
        var units = cd.querySelectorAll('[data-u]');
        var iv;
        var tick = function () {
          if (!root.isConnected) { clearInterval(iv); return; }
          var d = end - Date.now();
          if (isNaN(end) || d <= 0) { cd.hidden = true; return; }
          var v = [Math.floor(d / 864e5), Math.floor(d % 864e5 / 36e5), Math.floor(d % 36e5 / 6e4), Math.floor(d % 6e4 / 1e3)];
          units.forEach(function (el, i) { el.textContent = String(v[i]).padStart(2, '0'); });
        };
        tick();
        iv = setInterval(tick, 1000);
      }
    }

    setTimeout(function () {
      if (main && !hidden(base + '_m')) {
        openMain();
        // Mobile: wait for the main popup to close so the corner never covers it.
        if (withMain && !window.matchMedia('(max-width: 767px)').matches) showCorner();
      } else {
        showCorner();
      }
    }, design ? 300 : delay);
  }

  function scan() {
    document.querySelectorAll('.ps-root:not([data-ps-init])').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
